// Components==============
import { faPlay } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import React, { useContext, useEffect, useState } from 'react';
import { AudioExerciseContext } from 'screens/AudioExercise/AudioExercise';
import { shake } from 'utilities/framerAnimations';
import { useAudio } from 'utilities/useAudio';
import { AudioTypingExerciseContext } from '../../AudioTypingExercise';
import './AnswerBlock.module.scss';
// =========================

type Status = 'initial' | 'wrong' | 'right';

const variants = {
    initial: {
        scale: 1,
    },
    wrong: {
        x: shake,
        transition: {
            duration: 0.8,
        },
    },
    right: {},
};

export default function AnswerBlock({
    text,
    answerText,
}: {
    text?: string | null;
    answerText: string | undefined;
}) {
    const [status, setStatus] = useState<Status>('initial');

    const { background } = useContext(AudioExerciseContext);

    const { current, userAnswers, answer } = useContext(
        AudioTypingExerciseContext
    );

    const { play } = useAudio({ text });

    useEffect(() => {
        if (!userAnswers[current]) return setStatus('initial');
        if (userAnswers[current].toLowerCase() === answer?.answer)
            return setStatus('right');
        setStatus('wrong');
    }, [answer, userAnswers]);

    return (
        <motion.div
            styleName={`answerblock ${status}`}
            initial="initial"
            whileHover={text ? { scale: 1.03 } : {}}
            whileTap={text ? { scale: 0.97 } : {}}
            onTap={text ? () => play() : undefined}
            animate={status}
            variants={variants}
            style={{
                background: background === 'desert' ? '#AD9993' : '',
                cursor: text ? 'pointer' : 'default',
            }}
        >
            {answerText ? (
                <div
                    styleName="text"
                    dangerouslySetInnerHTML={{ __html: answerText }}
                />
            ) : text ? (
                <FontAwesomeIcon icon={faPlay} styleName="play" />
            ) : (
                <></>
            )}
        </motion.div>
    );
}
